import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Container, Card, Form, Button, Alert } from "react-bootstrap";
import Cookies from "universal-cookie";
import logo from "../assets/mboxLogo.jpeg";
import { getUser } from "../api/api";
import LoadingSpinner from "./LoadingSpinner";
import { Helmet } from 'react-helmet';

const Login = ({ handleLogin }) => {
  const cookies = new Cookies();
  const navigate = useNavigate();
  const correoElectronico = cookies.get("correoElectronico");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const inicioDeSesion = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const consultarUsuario = await getUser(email, password);

      if (consultarUsuario.ok && consultarUsuario.status === 200) {
        // Guardar todas las cookies necesarias
        cookies.set(
          "nombre_Completo",
          consultarUsuario.data.user.nombre_Completo,
          { path: "/" }
        );
        cookies.set(
          "correoElectronico",
          consultarUsuario.data.user.correoElectronico,
          { path: "/" }
        );
        cookies.set("id_Usuario", consultarUsuario.data.user.id_Usuario, {
          path: "/",
        });
        cookies.set("token", consultarUsuario.data.token, {
          path: "/",
        });

        // Eliminar el setTimeout
        handleLogin();
        navigate("/dashboard", { replace: true });
      } else if (consultarUsuario.status === 401) {
        setError("Usuario y/o Contraseña Incorrecta");
      } else {
        setError("Ha Ocurrido un Error: " + consultarUsuario.status);
      }
    } catch (error) {
      setError("Error de conexión con el servidor");
    } finally {
      setIsLoading(false);
    }
  };
  if (correoElectronico) {
    return <Navigate to='/dashboard' replace />;
  }

  return (
    <>
    <Helmet>
  <meta name="robots" content="noindex, nofollow" />
</Helmet>
      <Container
      fluid
      className='d-flex justify-content-center align-items-center vh-100'
      style={{
        background: "linear-gradient(135deg, #f9f9f9, #e6ecf4)",
      }}
    >
      <Card
        style={{
          width: "400px",
          padding: "30px",
          borderRadius: "20px",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Card.Body>
          <div className='text-center mb-4'>
            <img
              src={logo}
              alt='MBox Logo'
              style={{ width: "120px", marginBottom: "10px" }}
            />
            <h3 style={{ color: "#1F2F50" }}>Iniciar Sesión</h3>
          </div>
          {error && <Alert variant='danger'> {error} </Alert>}
          <Form onSubmit={inicioDeSesion}>
            <Form.Group className='mb-3' controlId='formBasicEmail'>
              <Form.Label>Correo Electrónico</Form.Label>
              <Form.Control
                type='email'
                placeholder='Ingrese su correo'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </Form.Group>

            <Form.Group className='mb-4' controlId='formBasicPassword'>
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                type='password'
                placeholder='Ingrese su contraseña'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </Form.Group>

            <Button
              style={{
                backgroundColor: "#F5A623",
                border: "none",
                width: "100%",
                color: "#fff",
                fontWeight: "bold",
              }}
              type='submit'
              disabled={isLoading}
            >
              {isLoading ? <LoadingSpinner small /> : "Iniciar Sesión"}
            </Button>

            <div className='text-center mt-3'>
              <Button
                variant='link'
                style={{ color: "#1F2F50", textDecoration: "none" }}
                onClick={() => navigate("/recuperar-contrasena")}
              >
                ¿Olvidaste tu contraseña?
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
    </>
  
  );
};

export default Login;
